import React from 'react';
import PropTypes from 'prop-types';
import {getColor} from '~/utils/catalog';
import {recordFromMmsColor} from '~/data/records/Color';
import Canvas from '~/shared/components/Canvas';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export function DesignPreview(props) {
  const {icons, view, style, colorId, ...others} = props;
  const color = getColor(style, colorId);
  return (
    <Canvas
      constraint={view.constraint}
      currentColorId={color.id}
      icons={icons}
      product={style}
      productColor={recordFromMmsColor(color)}
      selectedView={view}
      {...others}
    />
  );
}

const propTypes = {
  colorId: PropTypes.string,
  icons: PropTypes.array,
  style: PropTypes.object,
  view: PropTypes.object
};

DesignPreview.propTypes = propTypes;

export default DesignPreview;
